export const cookieStorage = {
    getItem: (key: string): boolean | undefined => {
        if (typeof document === 'undefined') {
            return undefined;
        }
        const cookies = document.cookie
            .split(';')
            .map((cookie) => cookie.split('='))
            .reduce<Record<string, string | undefined>>((acc, [key, value]) => ({ ...acc, [key.trim()]: value }), {});
        switch (cookies[key]) {
            case 'true':
                return true;
            case 'false':
                return false;
            default:
                return undefined;
        }
    },
    setItem: (
        key: string,
        value: boolean,
        options?: {
            expires?: Date;
            path?: string;
        }
    ) => {
        const cookie = [`${key}=${value}`];
        if (options?.expires) {
            cookie.push(`expires=${options.expires.toUTCString()}`);
        }
        if (options?.path) {
            cookie.push(`path=${options.path}`);
        }
        document.cookie = cookie.join('; ');
    },
    removeItem: (key: string) => {
        document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
};

/** The query flag the sales demo (b2b `/demo`) appends to a site it frames. */
export const SALES_DEMO_FRAME_PARAM = 'cineamo-demo';

/**
 * Whether this page is framed by the sales demo. The cookie banner stays shut there: over a showcase it is all a
 * prospect would see, and without a saved decision nothing optional loads anyway. Both conditions, so a bookmarked
 * or shared `?cineamo-demo` link opened on its own still asks.
 */
export function isSalesDemoFrame(): boolean {
    return (
        typeof window !== 'undefined' &&
        window.self !== window.top &&
        new URLSearchParams(window.location.search).has(SALES_DEMO_FRAME_PARAM)
    );
}
